// "Excel'e Aktar" — KPI Veri Girişi başlığı (M16 T22, K26). Canlı setin formüllü xlsx'ini indirir
// (`GET /kpi/sets/:setId/export.xlsx?years=…`). Bağlama: KpiTablePage toolbar'ındaki disabled
// yer tutucu butonun yerine `<KpiExportButton setId={grid?.setId ?? null} years={years} />`.
// Prop'lar store'dan prop-drilling ile gelir (cross-domain store çekme yok).
// güvenlik/UX taraması 2026-10-08 (U-L2 / Codex #5): kopya `KPI_COPY.export` tek kaynağına taşındı,
// hata rengi tanımsız `--color-danger` yerine `--color-error`.

import { useState } from "react";
import { KPI_DEFAULT_LANG, KPI_LANGS, type KpiLang } from "@mahir/shared";
import { ApiError } from "../../api/client";
import { downloadKpiSetExcel } from "../../api/kpi-export";
import { KPI_COPY } from "../../lib/kpi-ui";

const E = KPI_COPY.export;

const btn: React.CSSProperties = {
  padding: "6px 12px",
  borderRadius: 8,
  border: "1px solid var(--color-border)",
  background: "var(--color-surface)",
  fontSize: "0.82rem",
  color: "var(--color-text)",
  minHeight: 34,
};

export function KpiExportButton({
  setId,
  years,
  disabled,
  langSelect = false,
  onDownload = downloadKpiSetExcel,
}: {
  setId: string | null;
  years: number[];
  disabled?: boolean;
  /** TODO-KPI-09 — TR/EN seçici göster (yalnız `lang` destekleyen indirme ucunda; portal kapalı). */
  langSelect?: boolean;
  /** T19 — portal: `downloadPortalSetExcel` (müşteri görünümü filtreli xlsx) */
  onDownload?: (setId: string, years: number[], lang?: KpiLang) => Promise<void>;
}): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [lang, setLang] = useState<KpiLang>(KPI_DEFAULT_LANG);
  const inactive = (disabled ?? false) || busy || !setId;

  async function handleClick(): Promise<void> {
    if (!setId) return;
    setBusy(true);
    setError(null);
    try {
      await onDownload(setId, years, langSelect ? lang : undefined);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : E.failed);
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="inline-flex items-center gap-2">
      {langSelect ? (
        <select
          aria-label={E.langLabel}
          title={E.langTitle}
          value={lang}
          disabled={inactive}
          onChange={(e) => setLang(e.target.value as KpiLang)}
          style={{ ...btn, padding: "6px 8px", opacity: inactive ? 0.5 : 1 }}
        >
          {KPI_LANGS.map((l) => (
            <option key={l} value={l}>
              {E.langShort[l]}
            </option>
          ))}
        </select>
      ) : null}
      <button
        type="button"
        style={{ ...btn, opacity: inactive ? 0.5 : 1 }}
        disabled={inactive}
        title={setId ? E.title : E.noSet}
        aria-busy={busy}
        onClick={() => void handleClick()}
      >
        {busy ? E.busy : E.label}
      </button>
      {error ? (
        <span role="alert" className="text-xs" style={{ color: "var(--color-error)" }}>
          {error}
        </span>
      ) : null}
    </span>
  );
}
